<template>
  <button
    class="button-action"
    :class="{
      'is-large': isLarge,
      'is-disabled': isDisabled,
      'has-thumbnail': !!data.thumbnail,
      'has-content': !!data.content,
      'animate__animated animate__shakeX': isInactive && !isFocused
    }"
    @click="validate">
    <el-image
      v-if="data.thumbnail"
      :src="data.thumbnail"
      alt="Véhicule"
      fit="cover" />
    <strong>
      <span>{{ data.label || '' }}</span>
    </strong>
    <span
      v-if="data.content"
      class="content">{{ data.content }}</span>
  </button>
</template>

<script>
export default {
  name: "ButtonAction",
  props: {
    data: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInactive: false,
      idleTimeout: null,
    }
  },
  mounted() {
    this.resetIdleTimeout()
  },
  methods: {
    resetIdleTimeout() {
      this.isInactive = false
      clearTimeout(this.idleTimeout)

      this.idleTimeout = setTimeout(() => {
        this.isInactive = true
        setTimeout(this.resetIdleTimeout, 1000)
      }, 5000)
    },
    validate() {
      if (this.isDisabled) {
        return
      }

      this.$emit("validate")
    },
  }
}
</script>

<style lang="scss" scoped>
.button-action {
  flex-shrink: 0;
  display: inline-block;
  background-color: color(plainWhite);
  padding: 6px 16px;
  text-align: left;
  font-size: 13px;
  color: color(deepSeaBlue);
  border: 2px solid color(deepSeaBlue);
  border-radius: 40px;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.6s ease;

  .el-image {
    width: 60px;
    height: 60px;
    float: left;
    border-radius: 50%;
  }

  .content {
    margin-top: 4px;
    display: block;
  }

  &.has-thumbnail {
    padding: 12px 24px 12px 12px;

    strong {
      display: block;
    }

    strong {
      margin-top: 16px;
    }

    .content,
    strong {
      margin-left: 72px;
    }
  }

  &.has-thumbnail.has-content strong {
    margin-top: 4px;
  }

  &:hover,
  &:focus {
    background-color: color(paperWhite);
  }

  &.is-disabled {
    background-color: color(gray04);
    color: color(plainWhite);
    border-color: color(gray04);
    cursor: not-allowed;
  }

  &.is-large {
    padding: 12px 24px;
    font-size: 15px;
    line-height: 24px;
  }
}
</style>
